import * as React from "react";
const SvgFiRrFaceShush = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-shush_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 1.912-.461 3.814-1.333 5.502a1 1 0 1 1-1.776-.918A9.9 9.9 0 0 0 22.001 12c0-5.514-4.486-10-10-10S2 6.486 2 12a9.97 9.97 0 0 0 5.455 8.91 1 1 0 0 1-.91 1.782A11.96 11.96 0 0 1 0 12C0 5.383 5.383 0 12 0s12 5.383 12 12m-8.5-7a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 5m-7 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 5M13 15v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0m5.324 5.483-.625.772a2 2 0 0 1-1.556.744h-3.144c-.551 0-1-.448-1-1v-1c0-.552.449-1 1-1h1c.551 0 1 .448 1 1a1 1 0 0 0 2 0c0-1.654-1.346-3-3-3h-1c-1.654 0-3 1.346-3 3v1c0 1.654 1.346 3 3 3h3.144a3.99 3.99 0 0 0 3.112-1.486l.625-.772a1 1 0 0 0-1.556-1.258m-2.856-9.604a1 1 0 0 0 1.065 1.694 9 9 0 0 0 1.134-.827.999.999 0 0 0-1.33-1.494 7 7 0 0 1-.868.628zm-6.936 0a7 7 0 0 1-.868-.628 1 1 0 0 0-1.33 1.494c.045.04.455.4 1.134.827a1 1 0 0 0 1.065-1.694z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-shush_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceShush;
